/**
 * Created by slava on 23.03.17.
 */
KeypadView = cc.Node.extend({
    avoidNode: "KeypadView",
    ctor: function (keypad) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);

        this.keypad = keypad;

        this.lettersContainer = new cc.Node();
        this.lettersContainer.setAnchorPoint(0.5, 0.5);
        this.addChild(this.lettersContainer);

        this.animationsContainer = new cc.Node();
        this.animationsContainer.setAnchorPoint(0.5, 0.5);
        this.addChild(this.animationsContainer);

        this.createField();
        this.addTouchListener();

        keypad.on("shuffle", this.shuffle.bind(this), this);
        keypad.on("status", this.status.bind(this), this);
        keypad.on("blockAdded", this.addBlockView.bind(this), this);
        keypad.on("touchStopped", this.removeTouchListener.bind(this), this);
        keypad.on("resize", this.resize.bind(this), this);
        keypad.on("hide", this.hide.bind(this), this);
        keypad.on("push", this.onPush.bind(this), this);
        keypad.on("pop", this.onPop.bind(this), this);

        this.resize(true);

        this.createEffects();

        this.debugId = "Keypad";
    },

    createEffects: function () {
        this.effects = [];
        let soundId = 0;
        while (bundles.game.urls[`nota_${soundId}`]) {
            this.effects.push(`board.nota.${soundId}`);
            soundId++;
        }
    },

    onResize: function () {
        this.resize(true);
    },

    onPush: function () {
        cleverapps.effects.fire(this.effects[(this.keypad.indexes.length - 1) % this.effects.length]);
    },

    onPop: function () {
        cleverapps.effects.fire(this.effects[this.keypad.indexes.length % this.effects.length]);
    },

    hide: function (f) {
        if (cleverapps.flags.keypadOnWinDisabled) {
            f();
            return;
        }

        this.setCascadeOpacityEnabledRecursively(true);

        this.runAction(new cc.Sequence(
            new cc.FadeOut(0.2),
            new cc.Hide(),
            new cc.CallFunc(f)
        ));
    },

    status: function (code, letters) {
        if (code === WordGame.STATUSES.BOARD) {
            letters.forEach((letter, order) => {
                const animation = new cleverapps.Spine(bundles.game.jsons.remove_letter_sparkles_json);
                this.animationsContainer.addChild(animation);
                animation.setAlignment(BaseBlockView.alignInTheGrid(letter.x, letter.y));

                this.runAction(new cc.Sequence(
                    new cc.DelayTime(0.075 * order + 0.1),
                    new cc.CallFunc(() => {
                        animation.setAnimation(0, "animation", false);
                        animation.setCompleteListenerRemove();
                    })
                ));
            });
        }

        if (code === WordGame.STATUSES.BOARD || code === WordGame.STATUSES.EXTRA) {
            const scene = cleverapps.Scenes.GetRunningScene();

            let pos1 = BaseBlockView.alignInTheGrid(letters[0].x, letters[0].y);
            let pos2 = BaseBlockView.alignInTheGrid(letters[letters.length - 1].x, letters[letters.length - 1].y);
            pos1 = scene.convertToNodeSpace(this.lettersContainer.convertToWorldSpace(pos1));
            pos2 = scene.convertToNodeSpace(this.lettersContainer.convertToWorldSpace(pos2));
            KeypadView.LAST_WORD_POSITION = cc.p((pos1.x + pos2.x) / 2, (pos1.y + pos2.y) / 2);
        }
    },

    removeTouchListener: function () {
        if (this.touchListener) {
            this.touchListener.remove();
            delete this.touchListener;
        }
    },

    addBlockView: function (block) {
        if (block === undefined) {
            return;
        }
        const view = BaseBlockView.CreateView(block);
        this.lettersContainer.addChild(view);
    },

    createField: function () {
        this.keypad.field.forEach(function (column) {
            column.forEach(this.addBlockView, this);
        }, this);
    },

    resize: function (silent) {
        const oldSize = this.getContentSize();
        this.setContentSize(this.keypad.getWidth() * cleverapps.styles.BaseBlockView.width, this.keypad.getHeight() * cleverapps.styles.BaseBlockView.height);

        let styles = cleverapps.styles.KeypadView.phone;
        if (cleverapps.resolution.mode !== cleverapps.WideMode.VERTICAL) {
            styles = cleverapps.styles.KeypadView.nonphone;
        }

        const sceneSize = cleverapps.resolution.getSceneSize();

        const availableWidth = sceneSize.width;

        const scaleX = (availableWidth - styles.paddingLeft - styles.paddingRight) / this.width;
        const scaleY = styles.height / this.height;
        const newScale = Math.min(scaleX, scaleY, 1);
        const leftX = sceneSize.width - availableWidth + styles.paddingLeft;
        const rightX = sceneSize.width - styles.paddingRight;
        const posX = (leftX + rightX) / 2;
        const newPosition = cc.p(posX, this.height / 2 * newScale + styles.paddingBottom);

        this.setAlignment(this.x + (this.width * this.scale - oldSize.width * this.scale) / 2, this.y + (this.height * this.scale - oldSize.height * this.scale) / 2);

        if (silent) {
            this.setScale(newScale);
            this.setAlignment(newPosition);
        } else {
            this.runAction(new cc.Spawn(
                new cc.ScaleTo(0.7, newScale),
                new cc.MoveTo(0.7, newPosition)
            ));
        }

        this.animationsContainer.setContentSize2(this.getContentSize());
        this.animationsContainer.setAlignment(this.width / 2, this.height / 2);

        this.lettersContainer.setContentSize2(this.getContentSize());
        this.lettersContainer.setAlignment(this.width / 2, this.height / 2);
    },

    shuffle: function () {
        const views = this.lettersContainer.children;

        views.forEach(function (view) {
            view.stopAllActions();
            view.moveToBlock();
            const newPos = BaseBlockView.alignInTheGrid(view.block.x, view.block.y);

            view.setLocalZOrder(view.block.y);

            const dist = Math.sqrt(Math.pow(newPos.x - this.x, 2) + Math.pow(newPos.y - this.y, 2));

            view.runAction(
                new cc.Spawn(
                    new cc.MoveTo(dist / 700, newPos).easing(cc.easeBackInOut(0.6)),
                    new cc.ScaleTo(0.3, 1)
                )
            ).setFinalize(() => {
                view.setPosition(newPos);
                view.moveToKeypad();
            });
        }, this);

        const animation = new cleverapps.Spine(bundles.game.jsons.shuffle_json);
        cleverapps.Scenes.GetRunningScene().addChild(animation);
        animation.setAlignment(cleverapps.styles.KeypadView.shuffleAnimation);
        animation.setAnimation(0, "animation", false);
        animation.setCompleteListenerRemove();

        cleverapps.effects.fire("scramble.shuffle");
    },

    addTouchListener: function () {
        this.removeTouchListener();
        this.touchListener = cleverapps.UI.onDrag(this, {
            instantDrag: true,
            onDragStart: this.onTouchBegan.bind(this),
            onDragMoveNotThrottled: this.onTouchMoved.bind(this),
            onDragEnd: this.onTouchEnded.bind(this)
        }, this);
    },

    onTouchBegan: function (touch) {
        if (this.touchId !== undefined) {
            return false;
        }

        const location = this.convertTouchToNodeSpace(touch);
        if (cc.rectContainsPoint(cc.rect(0, 0, this.width, this.height), location)) {
            const letter = this.calcLetterTouched(location);
            if (letter) {
                const res = this.keypad.touchBegan(letter.block);
                if (res) {
                    this.touchId = touch.getID();
                    this.startLetter = letter;
                    return true;
                }
            }
        }

        return false;
    },

    onTouchMoved: function (touch) {
        if (touch.getID() !== this.touchId) {
            return false;
        }

        const move = this.calcDirection(this.startLetter, this.convertTouchToNodeSpace(touch));
        if (move) {
            this.keypad.touchMoved(this.startLetter.block, move);
        }
    },

    onTouchEnded: function (touch) {
        if (touch.getID() !== this.touchId) {
            return false;
        }

        this.keypad.touchEnded();
        this.touchId = undefined;
        this.startLetter = undefined;
        return true;
    }
});

KeypadView.prototype.calcLetterTouched = function (touchPos) {
    const col = Math.floor(touchPos.x / cleverapps.styles.BaseBlockView.width);
    const row = Math.floor(touchPos.y / cleverapps.styles.BaseBlockView.height);

    if (!this.keypad.field[col] || !this.keypad.field[col][row] || !(this.keypad.field[col][row] instanceof LetterBlock)) {
        return undefined;
    }

    return this.keypad.field[col][row].onLocateView();
};

KeypadView.prototype.calcDirection = function (start, end) {
    if (!cc.rectContainsPoint(cc.rect(0, 0, this.width, this.height), end)) {
        return;
    }

    let dx = end.x - start.x;
    let dy = end.y - start.y;

    let minDist = Number.MAX_VALUE;
    let minDirection;
    for (let dirNo = 0; dirNo < BlockMixer.DIRECTIONS.length; dirNo++) {
        const direction = BlockMixer.DIRECTIONS[dirNo];

        const dist = Math.pow((dx - direction.x), 2) + Math.pow((dy - direction.y), 2);

        if (dist < minDist) {
            minDist = dist;
            minDirection = direction;
        }
    }

    dx *= minDirection.x;
    dy *= minDirection.y;

    const length = Math.round(dx / cleverapps.styles.BaseBlockView.width) + Math.round(dy / cleverapps.styles.BaseBlockView.height);

    return {
        direction: minDirection,
        length: length + 1
    };
};

cleverapps.styles.KeypadView = {
    letter: {
        width: 100,
        height: 100
    },

    shuffleAnimation: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -100 }
    },

    phone: {
        paddingBottom: 145,
        paddingLeft: 12,
        paddingRight: 12,
        height: 720
    },

    nonphone: {
        paddingBottom: 15,
        paddingLeft: 270,
        paddingRight: 270,
        height: 810
    }
};
